(function () {
    'use strict';

    angular.module('swif.interventions')
    .controller('RequestValidateSurveyModalController', RequestValidateSurveyModalController);



    function RequestValidateSurveyModalController ($scope, swif) {
        'ngInject';
        $scope.validationOrder = {};
        $scope.doneItems = [];
        $scope.activeBlock = {};
        $scope.currentUser = swif.user.getAuthenticatedUserData();
        $scope.initializeValidation = initializeValidation;
        initializeValidation();

        function computeValidationItem (model) {
            return {
                user_id: model.creator_id,
                note: model.name,
                date: model.create_date,
                state: 'init'
            };
        }
        function initializeValidation () {
            if ($scope.model.validation_order_id) {
                var vid = $scope.model.validation_order_id[0];
                swif.data.get('validation-order', vid).then(function (data) {
                    // copy validation data to the Object
                    _.merge($scope.validationOrder, data);

                    // retrieve the items already done (confirmed, refused)
                    // to be displayed in the history queue
                    $scope.doneItems = swif.validation.getDoneItems($scope.validationOrder);
                    // then, create an 'item' based on validation data,
                    // to add it on the begining history queue
                    var modelItem = computeValidationItem($scope.validationOrder);
                    $scope.doneItems.splice(0, 0, modelItem);
                    // finally, retrieve the message sent to the connected user,
                    //by the one having initialized the validation process
                    $scope.activeBlock = swif.validation.getUserBlockItem($scope.validationOrder);

                });
            }
        }

    }



})();
